import React, { useEffect, useState } from 'react';
import './CalcAProofDtMode.css';

import { CalcAProofResult } from '../parts/CalcAProofData';

type Props = {
    calcResult: CalcAProofResult
  }
  
export const CalcAProofDtMode: React.FC<Props> = ({calcResult}) => {

    return (
        <div className="CalcAProofDtMode_content CalcAProofDtMode_table">
            <table>
                <thead>
                </thead>
                <tbody>
                    <tr>
                        <th>
                            &nbsp;Target NaOH Production
                        </th>
                        <td className='CalcAProofDtMode_cell_unit'>MT/D</td>
                        <td>
                            {
                                calcResult.calculationMode?.targetNaoh?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                        </td>
                    </tr>
                    <tr>
                        <th className='CalcAProofDtMode_cell_hidden'>
                            Calculation Mode
                        </th>
                        <td className='CalcAProofDtMode_cell_unit CalcAProofDtMode_cell_hidden'>-</td>
                        <td className='CalcAProofDtMode_cell_hidden'>{calcResult.calculationMode?.mode}</td>
                    </tr>
                    <tr>
                        <th className='CalcAProofDtMode_cell_hidden'>
                            &nbsp;Target Cl2 Production
                        </th>
                        <td className='CalcAProofDtMode_cell_unit CalcAProofDtMode_cell_hidden'>MT/D</td>
                        <td className='CalcAProofDtMode_cell_hidden'>
                            {
                                calcResult.calculationMode?.targetCl2?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                        </td>
                    </tr>
                    <tr>
                        <th className='CalcAProofDtMode_cell_hidden'>
                            &nbsp; Cl2 Efficiency
                        </th>
                        <td className='CalcAProofDtMode_cell_unit CalcAProofDtMode_cell_hidden'>%</td>
                        <td className='CalcAProofDtMode_cell_hidden'>
                            {
                                calcResult.calculationMode?.cl2Efficiency?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                            {calcResult.calculationMode?.cl2Efficiency ? "%" : ""}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
